var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutctashap3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 212,
    viewBox: "0 0 211 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Highlight Sparkle 5",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M98.5728 55.7753C104.621 59.714 107.224 57.5337 106.591 49.1641C106.028 41.9901 100.401 37.8403 98.4321 43.0449C96.6034 47.7573 96.7441 54.5797 98.5728 55.7753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M82.1857 61.8949C85.1397 63.5125 94.5644 63.7236 96.5337 62.3169C100.824 59.2223 87.1794 55.1429 80.9197 57.6749C78.6691 58.5189 79.2317 60.2772 82.1857 61.8949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M96.6039 66.0439C92.3839 72.8661 99.8392 84.8931 104.692 79.0554C106.099 77.3674 105.324 69.1385 103.566 67.3802C101.808 65.6922 97.3775 64.7779 96.6039 66.0439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M117.986 63.1603C125.863 62.1053 126.567 61.8943 126.567 60.4173C126.567 57.2523 118.127 55.9159 110.882 57.8149C101.809 60.3469 107.506 64.5669 117.986 63.1603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M100.825 145.24C97.238 143.552 85 143.622 85 145.381C85 147.702 89.0793 149.319 95.6907 149.671C104.06 150.023 106.522 147.913 100.825 145.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M144.29 69.4907C135.006 73.3589 124.386 82.4319 110.882 88.7619C100.191 93.7556 93.8612 93.5446 86.6168 89.5356C78.0362 84.8936 73.5348 85.8079 77.6845 91.3643C83.8738 99.6636 82.7485 110.003 74.8008 117.317C67.9781 123.577 75.5035 127.445 85.9831 123.085C92.9461 120.201 93.7205 120.271 102.301 124.773C112.71 130.259 114.891 129.977 115.242 123.366C115.524 116.755 117.563 110.003 120.588 105.642C125.3 98.6789 142.461 80.7439 148.158 76.8053C155.895 71.4599 155.684 64.7783 144.29 69.4907ZM109.686 100.648C106.732 105.079 105.255 109.299 104.903 114.012C104.341 122.03 104.622 117.528 92.9468 115.137C89.0082 114.363 88.5862 114.082 88.9378 112.816C90.9775 105.712 90.9775 102.829 88.8675 97.2723C88.5862 96.5689 89.7115 96.7096 92.9468 97.7646C95.4085 98.5383 99.1362 99.2416 101.246 99.3119C105.677 99.4526 108.912 98.7493 111.233 98.3273L109.686 100.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M84.9286 143.2C86.6166 138.628 86.547 135.041 84.7183 133.212C82.538 131.032 78.3883 130.751 77.3333 132.65C76.4893 134.197 76.9817 136.096 77.1223 139.683C77.3333 144.184 83.522 146.998 84.9286 143.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M77.6853 153.891C76.2787 156.141 76.9813 167.465 78.599 168.801C83.8036 173.021 86.688 169.223 85.0703 160.221C84.0153 154.453 79.6547 150.726 77.6853 153.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M59.1865 143.833C57.2172 144.255 57.1468 145.591 59.1161 147.279C61.2261 149.178 74.3084 149.741 74.9414 147.912C76.2074 144.677 66.7825 142.215 59.1865 143.833Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutctashap3);
export default __webpack_public_path__ + "static/media/aboutctashap-3.200df404aee80485c377627a04b820d5.svg";
export { ForwardRef as ReactComponent };